import { BACKEND_URL } from "@/lib/api";

export const fmtTL = (n) =>
  new Intl.NumberFormat("tr-TR").format(Math.round(Number(n) || 0)) + " ₺";

export const fmtGram = (n) =>
  new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n) || 0);

export const imgUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("/api")) return `${BACKEND_URL}${u}`;
  return u;
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("tr-TR", {
      day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const hasFactor = (karat) => {
  const k = parseFloat(karat);
  return Number.isFinite(k) ? k / 24 : 0;
};

// Pure has + işçilik has (milyem/1000) for a single product line
export const lineHasParts = (product, quantity = 1) => {
  const g = (Number(product.gram) || 0) * quantity;
  const pure = g * hasFactor(product.karat);
  const isc = g * ((Number(product.milyem) || 0) / 1000);
  return { gram: g, pure, isc, total: pure + isc };
};

// Aggregate cart items ({ product, quantity }) into gram-based totals
export const computeCart = (items) => {
  const map = {};
  let totalGram = 0, totalPureHas = 0, totalIscHas = 0;
  items.forEach(({ product, quantity }) => {
    const { gram, pure, isc } = lineHasParts(product, quantity);
    const k = String(product.karat || "");
    if (!map[k]) map[k] = { gram: 0, has: 0 };
    map[k].gram += gram;
    map[k].has += pure;
    totalGram += gram;
    totalPureHas += pure;
    totalIscHas += isc;
  });
  const breakdown = Object.entries(map)
    .map(([karat, v]) => ({ karat, gram: v.gram, has: v.has }))
    .sort((a, b) => hasFactor(b.karat) - hasFactor(a.karat));
  return { breakdown, totalGram, totalPureHas, totalIscHas, totalHas: totalPureHas + totalIscHas };
};

export const STATUS_COLORS = {
  "Yeni Sipariş": "bg-blue-500/15 text-blue-400 border-blue-500/30",
  "Sipariş Onaylandı": "bg-purple-500/15 text-purple-400 border-purple-500/30",
  "Hazırlanıyor": "bg-amber-500/15 text-amber-400 border-amber-500/30",
  "Kargoya Verildi": "bg-cyan-500/15 text-cyan-400 border-cyan-500/30",
  "Tamamlandı": "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  "İptal Edildi": "bg-red-500/15 text-red-400 border-red-500/30",
  "Reddedildi": "bg-rose-600/15 text-rose-400 border-rose-600/30",
};
